module.exports = __webpack_public_path__ + "static/media/B-Static.d69649d4.png";